<template>
    <div class="phone-number-component">
        <button v-if="!numberVisible" class="btn show-phone-number bg-teal d-flex align-items-center mb-4" @click="getNumber">
            <span class="phone-icon mb-0 d-inline-block"></span>
            <span class="d-inline-block fs-5">Afficher le numéro</span>
        </button>

        <div v-if="numberVisible" class="mb-3">
            <div class="d-flex align-items-center justify-content-center purple-border bg-white mb-1">
                <div class="w-50 d-flex align-items-center justify-content-center">
                    <a :href="'tel:'+phone.number" class="text-purple fw-bold fs-5">{{ phone.numberFormated }}</a>
                </div>

                <div class="w-50 bg-purple py-1 pe-1 d-flex justify-content-center">
                    <div class="phone-arrow my-auto"></div>
                    <p class="lh-1 small mb-0 text-white ms-1">Service {{ phone.price }}€ / appel + prix appel</p>
                </div>
            </div>
            <div class="hiconnect-text-condition lh-sm">Service 2.99€ / appel + prix appel. Ce numéro valable 5 minutes n'est pas le numéro du destinataire mais le numéro d'un service permettant la mise en relation avec celui-ci. Ce service est édité par le site Justacote. <a href="http://mise-en-relation.svaplus.fr/">Pourquoi ce numéro ?</a></div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        poiid: String,
    },

    data() {
        return {
            poiId: null,
            numberVisible: false,
            phone: {
                number: null,
                numberFormated: null,
                price: null
            }
        }
    },

    mounted() {
        this.poiId = parseInt(this.poiid)
    },

    methods: {
        getNumber() {
            axios.get(`/api/v1/pois/${this.poiId}/payphone`)
                .then((response) => {
                    this.numberVisible = true
                    this.phone.number = response.data.tel
                    this.phone.price = response.data.price

                    let number = response.data.tel.match(/^(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/)
                    this.phone.numberFormated = `${number[1]} ${number[2]} ${number[3]} ${number[4]} ${number[5]}`
                })
                .catch((error) => {
                    console.log('Erreur ! ' + error)
                })
        },
    }
};
</script>
